module.exports = __webpack_public_path__ + "static/media/humidity.cb902e65.svg";